export const getStageHandler = (props: any) => {
  const { stepName, stage, isInitialInfo, isNafath } = props;

  if (isInitialInfo && stepName === 'services') {
    return 'INITIAL_INFORMATION';
  }
  switch (stage) {
    case 'ksaApplication':
      switch (stepName) {
        case 'services':
          return 'PRODUCTS';

        case 'application.companyInformation':
          return 'BUSINESS_DETAILS';

        case 'application.managers':
          return 'BUSINESS_OWNER';

        case 'application.bankAccount':
          return 'BANK_DETAILS';

        case 'application.reviewAndSubmit':
          return 'REVIEW_CONFIRM';

        default:
          return 'PRODUCTS';
      }
    case 'ksaContract':
      if (isNafath) {
        return 'NAFATH';
      }
      return 'AGREEMENT';
    default:
      return 'ON_REVIEW';
  }
};
